(function () {
  "use strict";

  if (customElements.get("product-notification")) return;

  customElements.define(
    "product-notification",
    class extends HTMLElement {
      constructor() {
        super();
        this.notificationForm = this.querySelector("[data-notification-form]");
        this.submitting = false;
      }

      connectedCallback() {
        if (!this.notificationForm) return;
        this.submitButton = this.notificationForm.querySelector('[type="submit"]');
        this.notificationForm.addEventListener("submit", (event) => this.handleSubmit(event));
      }

      // Route the sold-out "notify me" signup to Klaviyo Back in Stock instead
      // of Shopify's native contact form. We always preventDefault, so the
      // native contact post never fires (no double-submit).
      handleSubmit(event) {
        event.preventDefault();
        if (this.submitting) return;

        const emailInput = this.notificationForm.querySelector('input[type="email"]');
        const email = emailInput ? emailInput.value.trim() : "";
        const variantId = this.getVariantId();
        const publicKey = this.dataset.klaviyoPublicKey;

        if (!email || !variantId || !publicKey) {
          this.showError();
          return;
        }

        this.setSubmitting(true);
        this.subscribe(publicKey, email, variantId)
          .then(() => this.showSuccess())
          .catch((error) => {
            console.error("[Klaviyo BIS] subscription failed", error);
            this.setSubmitting(false);
            this.showError();
          });
      }

      // Current client-side Back in Stock API. Falls back to the legacy onsite
      // endpoint only if the current one rejects, so a signup is never sent twice.
      subscribe(publicKey, email, variantId) {
        return this.subscribeClient(publicKey, email, variantId).catch(() =>
          this.subscribeOnsite(publicKey, email, variantId)
        );
      }

      subscribeClient(publicKey, email, variantId) {
        return fetch(
          "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" +
            encodeURIComponent(publicKey),
          {
            method: "POST",
            headers: {
              "Content-Type": "application/vnd.api+json",
              revision: "2026-04-15",
            },
            body: JSON.stringify({
              data: {
                type: "back-in-stock-subscription",
                attributes: {
                  profile: {
                    data: {
                      type: "profile",
                      attributes: { email: email },
                    },
                  },
                  channels: ["EMAIL"],
                },
                relationships: {
                  variant: {
                    data: {
                      type: "catalog-variant",
                      // Klaviyo catalog-variant id for a Shopify-synced catalog.
                      id: "$shopify:::$default:::" + variantId,
                    },
                  },
                },
              },
            }),
          }
        ).then((response) => {
          if (!response.ok) throw new Error("client endpoint " + response.status);
          return response;
        });
      }

      subscribeOnsite(publicKey, email, variantId) {
        const body = new URLSearchParams({
          a: publicKey,
          email: email,
          variant: variantId,
          platform: "shopify",
        });
        return fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: body.toString(),
        }).then((response) => {
          if (!response.ok) throw new Error("onsite endpoint " + response.status);
          return response;
        });
      }

      // Prefer the live add-to-cart variant input (product-info.js keeps it in
      // sync as the shopper switches variants); fall back to the value baked
      // into the form at render time.
      getVariantId() {
        const scope = this.closest("product-info") || document;
        const liveInput =
          scope.querySelector('input[name="id"].product-variant-id') ||
          scope.querySelector('input[name="id"]');
        const liveId = liveInput && liveInput.value ? liveInput.value.trim() : "";
        return liveId || this.notificationForm.getAttribute("data-variant-id") || "";
      }

      setSubmitting(state) {
        this.submitting = state;
        if (this.submitButton) this.submitButton.disabled = state;
      }

      showSuccess() {
        this.clearError();
        // Reuses the theme's existing success styling: `.has-success` reveals
        // the success message and hides the form (see theme.css).
        this.parentNode.classList.add("has-success");
      }

      showError() {
        let el = this.notificationForm.querySelector("[data-notification-error]");
        if (!el) {
          el = document.createElement("div");
          el.setAttribute("data-notification-error", "");
          el.className = "product__notification__message";
          el.style.color = "var(--color-error, #c0392b)";
          el.style.marginTop = "8px";
          this.notificationForm.appendChild(el);
        }
        el.textContent =
          window.theme && window.theme.strings && window.theme.strings.notificationError
            ? window.theme.strings.notificationError
            : "Sorry, something went wrong. Please try again.";
        el.style.display = "block";
      }

      clearError() {
        const el = this.notificationForm.querySelector("[data-notification-error]");
        if (el) el.style.display = "none";
      }
    }
  );
})();
